import React, { useState, useRef, useEffect } from 'react';
import { Chart, registerables } from 'chart.js';
import { ChartDataset } from '../../model/ChartDataset';
import { getTooltip } from '../../model/Chart';
Chart.register(...registerables);

const BarChart = ({ datasets, labels, displayGrid, displayY, height }: Props) => {
  const chartRef = useRef();
  const [chart, setChart] = useState<any>(null);

  useEffect(() => {
    if(chart) {
      chart.destroy();
    }
    setChart(new Chart(chartRef.current, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        color: '#646467',
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: getTooltip()
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              display: displayGrid,
              color: '#F2F3F7'
            },
            ticks: {
              color: '#646467',
              minRotation: 0,
              maxRotation: 0,
              autoSkip: false,
              callback: (value, index) => {
                const label = labels[index];
                const maxLength = 7;
                return label.length > maxLength ? label.substring(0, maxLength) + '…' : label;
              }
            },
            border: {
              display: false
            }
          },
          y: {
            display: displayY,
            stacked: true,
            grid: {
              display: displayGrid,
              color: '#F2F3F7'
            },
            ticks: {
              display: true,
              stepSize: 20
            }
          }
        }
      }
    }));
  }, [ datasets, labels ]);

  const style = { height: height || '100%'};
  return (
    <div className="d-flex align-items-center" style={style}>
      <canvas ref={chartRef}></canvas>
    </div>
  );
}

interface Props {
  datasets: ChartDataset[],
  labels: string[],
  displayGrid: boolean,
  displayY?: boolean,
  height?: number
}

export { BarChart };